module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/8f4da7337f846fcf7b3714e0e0222c90.png";